<template>
  <div class="paginationBox">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="getList"
      :current-page.sync="pagedata.currentPage"
      :page-sizes="pageSizes"
      :page-size.sync="pagedata.pageSize"
      background
      :pager-count="pagerCount"
      :layout="layout"
      :total="pagedata.total"
      :hide-on-single-page="false"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    layout: {
      default: "total, sizes, prev, pager, next, jumper"
    },
    pagedata: {
      type: Object,
      // default: {
      //   pageSize: 10,
      //   currentPage: 1,
      //   total: 0
      // }
    },
    pageSizes: {
      default: () => [10, 15, 20, 50, 100]
    },
    pagerCount: {
      default: 7
    }
  },

  watch: {
    pagedata: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.total > 0 && val.total < val.pageSize * (val.currentPage - 1)) {
          this.pagedata.currentPage = 1;
          this.getList();
        }
      }
    }
  },
  methods: {
    handleSizeChange() {
      this.pagedata.currentPage = 1;
      this.getList();
    },
    getList() {
      this.$emit("getList", this.index);
    }
  },
  computed: {
    index() {
      return (this.pagedata.currentPage - 1) * this.pagedata.pageSize + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.paginationBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0 40px 0;
  text-align: right;

  ::v-deep .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next {
    width: 30px;
    height: 30px;
    border: 1px solid $border-input-color;
    background: #fff;
    border-radius: 2px;
  }
  ::v-deep .el-pager li {
    border: 1px solid $border-input-color;
    background: #fff;
  }
  ::v-deep .btn-next {
    border: 1px solid $border-input-color;
    background: #fff !important;
  }
  ::v-deep .el-pagination__editor.el-input {
    width: 50px;
    margin: 0 12px;
  }
  ::v-deep .el-pagination .el-select .el-input .el-input__inner {
    padding-right: 25px;
    border-radius: 2px;
    height: 30px;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: $theme-color;
    color: #ffffff;
    border: none;
  }
}
</style>
